import { connect } from "react-redux";
import * as Redux from "redux";
import { getMerchants } from "../../actions";
import ViewMerchant from "./component";
import { Merchant } from "../../";

export interface ViewMerchantsProps {
  merchants: Merchant[];
}

export interface ViewMerchantsActions {
  getMerchants: (q?: string) => void;
}

const mapStateToProps = (state: any): ViewMerchantsProps => {
  return {
    merchants: state.merchant
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): ViewMerchantsActions => {
  return {
    ...Redux.bindActionCreators({ getMerchants }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewMerchant);



// WEBPACK FOOTER //
// ./client/modules/Merchant/components/ViewMerchants/container.ts